import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';
import type { GroundingMenuItemSkeletonSlots, GroundingMenuItemSkeletonState } from './GroundingMenuItemSkeleton.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const groundingMenuItemSkeletonClassNames: SlotClassNames<GroundingMenuItemSkeletonSlots> = {
  root: 'fai-GroundingMenuItemSkeleton',
  avatar: 'fai-GroundingMenuItemSkeleton__avatar',
  primaryText: 'fai-GroundingMenuItemSkeleton__primaryText',
  secondaryText: 'fai-GroundingMenuItemSkeleton__secondaryText',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateRows: 'auto auto',
    gridTemplateColumns: 'auto 1fr',
    columnGap: tokens.spacingHorizontalM,
    rowGap: tokens.spacingVerticalXS,
    alignItems: 'center',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalNone}`,
  },
  avatar: {
    gridRow: 'span 2',
  },
  primaryText: { width: 'min(100%, 136px)' },
  secondaryText: { width: 'min(100%, 184px)' },
});

/**
 * Apply styling to the GroundingMenuItemSkeleton slots based on the state
 */
export const useGroundingMenuItemSkeletonStyles_unstable = (
  state: GroundingMenuItemSkeletonState,
): GroundingMenuItemSkeletonState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(groundingMenuItemSkeletonClassNames.root, styles.root, state.root.className);

  if (state.avatar) {
    state.avatar.className = mergeClasses(
      groundingMenuItemSkeletonClassNames.avatar,
      styles.avatar,
      state.avatar.className,
    );
  }

  if (state.primaryText) {
    state.primaryText.className = mergeClasses(
      groundingMenuItemSkeletonClassNames.primaryText,
      styles.primaryText,
      state.primaryText.className,
    );
  }

  if (state.secondaryText) {
    state.secondaryText.className = mergeClasses(
      groundingMenuItemSkeletonClassNames.secondaryText,
      styles.secondaryText,
      state.secondaryText.className,
    );
  }

  return state;
};
